import { Middleware } from 'redux';
import * as Actions from '../actions';
import User from '../../data/User';
import { RENDERER_EMAIL } from '../../data/Config';
import { WILL_START_RENDERING_QUEUE } from '../actions/index';

const handler: Middleware =
  (store: any) => (next: Function) => (action: any) => {
    next(action);

    if (action.type === Actions.USER_SIGN_IN) {
      if (action.user && (action.user as User).email === RENDERER_EMAIL) {
        store.dispatch({ type: WILL_START_RENDERING_QUEUE });
        // alert('START CLOUD RENDERINGS');
        // render queue until is empty
        // when empty, register to new additions
      }
    }
  };

export default handler;



// WEBPACK FOOTER //
// ./src/state/side-effects/startCloudRenderings.ts